var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGigmiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 41,
    viewBox: "0 0 124 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 11",
    d: "M0 17.1369V17.0417C0 7.28428 7.70437 0 18.0242 0C23.6277 0 28.1574 1.8681 31.7051 4.94945L25.5882 12.327C23.4407 10.5063 21.0585 9.47881 18.3506 9.47881C14.101 9.47881 11.0201 12.7471 11.0201 17.1832V17.2761C11.0201 21.8995 14.2413 25.0749 18.8177 25.0749C20.6858 25.0749 21.7129 24.7959 22.5531 24.3272V21.0589H16.9504V14.0552H32.7797V29.1842C29.2324 32.0794 24.2809 34.0866 18.3514 34.0866C8.1707 34.0874 0 27.2694 0 17.1369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 107",
    d: "M46.3717 7.89172H35.7717V33.3867H46.3717V7.89172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 12",
    d: "M49.0812 37.7762L52.3494 31.3783C55.1984 32.8726 58.0466 33.806 61.5489 33.806C65.5178 33.806 67.6191 31.7522 67.6191 28.2025V27.4564C66.1715 29.0905 63.79 30.9578 60.2411 30.9578C53.6568 30.9578 48.8942 26.2882 48.8942 19.2371V19.145C48.8942 12.0002 53.7504 7.28394 59.6337 7.28394C63.3699 7.28394 65.5645 8.68451 67.4318 10.5988V7.89136H78.0318V26.943C78.0318 31.6593 77.0509 34.8806 74.716 37.2154C72.4282 39.504 68.926 40.9516 63.2296 40.9516C57.5799 40.9516 53.19 39.8308 49.0804 37.7766L49.0812 37.7762ZM67.6649 19.192V19.0984C67.6649 16.9034 65.9842 15.1294 63.4154 15.1294C60.8003 15.1294 59.1658 16.9501 59.1658 19.192V19.2849C59.1658 21.4798 60.8474 23.2068 63.4154 23.2068C66.0304 23.2068 67.6649 21.4332 67.6649 19.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13",
    d: "M81.066 8.12134H89.8744L95.2882 16.9999L100.7 8.12134H109.509V33.3867H101.099V20.864L95.2878 29.8514H95.144L89.3332 20.864V33.3871H81.066V8.12134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 108",
    d: "M123.231 7.89172H112.631V33.3867H123.231V7.89172Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigmiLogo);
export default __webpack_public_path__ + "static/media/gigmi-logo.61b7b4f60c5e550d749f94c71f93939a.svg";
export { ForwardRef as ReactComponent };